<template>
  <div :class="ui.bkgdColor">
      <v-layout class="text-xs-right mt-2 mr-2">
        <v-spacer/>
        <v-btn :color="ui.textSubheading"
        :disabled="getLimitsList.length > 30 || !this.enableDocumentItemAdd()"
        flat icon @click="openDialog()">
          <v-icon :color="ui.btnColor"> add </v-icon>
        </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title class="title wplblue0--text">
            New Business Limit
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <div>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm9>
                    <v-text-field
                    v-model="localForm.title"
                    label="limit name"
                    :rules="ruleMustBeFilledANDLessThan50"
                    prepend-icon="title"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-select
                    v-model="localForm.type"
                    :items="limitsTypeOptions"
                    :rules="ruleMustBeSelected"
                    label="type"
                    prepend-icon="grid_view"
                    hint="part type"
                    required
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm6>
                    <v-text-field
                    v-model="localForm.id"
                    label="limit id"
                    :rules="ruleMustBeFilledANDLessThan50"
                    prepend-icon="fingerprint"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                    v-model="localForm.dis"
                    :items="engineeringDiscipline"
                    label="discipline"
                    :rules="ruleMustBeSelected"
                    prepend-icon="engineering"
                    hint="discipline"
                    required
                    >
                  </v-select>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm6>
                    <v-text-field
                    v-model="localForm.limid"
                    label="limit key"
                    :rules="ruleMustBeFilledANDLessThan50"
                    prepend-icon="pin"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="this.localForm.type === 'Time'">
                    <v-text-field
                    v-model="localForm.limval"
                    label="limit value"
                    :rules="ruleNumberMoreThanZero"
                    prepend-icon="schedule"
                    suffix="hrs"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="this.localForm.type === 'PerHr'">
                    <v-text-field
                    v-model="localForm.limval"
                    label="limit value"
                    :rules="ruleNumberMoreThanZero"
                    prepend-icon="person"
                    suffix="ph"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="this.localForm.type === 'Cost'">
                    <v-text-field
                    v-model="localForm.limval"
                    label="limit value"
                    :rules="ruleNumberMoreThanZero"
                    prepend-icon="paid"
                    suffix="AUD"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="this.localForm.type === 'Carbon'">
                    <v-text-field
                    v-model="localForm.limval"
                    label="limit value"
                    :rules="ruleNumberMoreThanZero"
                    prepend-icon="co2"
                    suffix="kg"
                    required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4 mb-2">
                  Business Limit Description
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="ruleMustBeNotUndefinedANDLessThan1000"
                  hint="additional  resource skills or licence"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat
            v-if="this.localForm.limval > 0"
            >
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import limitsOptions from "@/data/options/mixins/limitsOptions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    techOptions,
    listFunctions,
    generateForms,
    financeFunctions,
    master,
    limitsOptions,
    rulesTextfield,
    uisettings,
    generateID,
    docRevsModFunctions,
    documentFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getLimitsList",
      "getLimitsListPrior",
      "getLimitsListCounter",
      "getLimitsListDisplay",
      "getCurrentPage",
      "getDetail",
      "getUser"
    ]),
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinner: false,
      ctr: 0,
      attachLast: null,
      attachListLocal: [],
      localForm: {
        id: "", // limitss Id
        title: "", // limitss title
        dis: "", // eng. discipline
        com: "", // limits comments
        rate: "",
        per: "", // person
        hrs: "", // hours
        type: "", // type
        limid: "", // limit id
        limval: "" // limit value
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeLimitsList", []);
      // this.$refs.form.reset();
    },
    validate() {
      // cosole.log(this.taskForm)
      // this.$refs.form.validate() === true
      if (this.$refs.form.validate() === true) {
        // NEW PART
        let tempForm = this.generateLimitsForm();

        // BASIC
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("DATE", "B7");
        tempForm.basic.idi = this.getLimitsListCounter + 1;
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;
        tempForm.basic.tag = "B7";

        // CHAR
        tempForm.char.type = this.localForm.type;
        tempForm.char.dis = this.localForm.dis;
        tempForm.char.limid = this.localForm.limid;
        tempForm.char.limval = this.localForm.limval;
        tempForm.char.com = this.localForm.com;

        // STATS
        tempForm.stats.dcrt = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getLimitsList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 50);

        // STORE UPDATE
        this.$store.dispatch("changeLimitsList", newList);
        this.$store.dispatch("changeLimitsListCounter", tempForm.basic.idi);
        this.saveDocumentRevMod(5.11, 1); // attachment added.
        this.$store.dispatch("changeDataSavePendingIndication", true);

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
